import { Trans } from '@lingui/react';
import React from 'react';
import styled from 'styled-components';
import Button from '@components/buttons';
import Label from '@components/form/Label';
import Icon from '@components/Icon';
import { Box, Flex } from '@components/layout/Grid';
import Span from '@components/layout/Span';
import Tag from '@components/Tag';
import { Footer, Header, Body, Modal } from './base';

const ClearButton = styled(Button)`
  margin: 0 0 0 auto;
`;

const SearchFiltersModal = props => {
  const selectedTaxonomy =
    props.taxonomies.find(
      taxonomy => taxonomy.slug === props.selectedTaxonomySlug
    ) || {};
  return (
    <Modal open={props.open} handleClose={props.clearAll}>
      <Header noCloseButton>
        <Box>
          <Icon
            name="ygb-icon-close"
            fontSize="13.5px"
            onClick={props.handleClose}
          />
          <Span marginLeft={15}>
            <Label>{selectedTaxonomy.name}</Label>
          </Span>
        </Box>
        <ClearButton appearance="link" onClick={props.clearAll}>
          <Trans id="metadata.clear_all" message={'Clear all'} />
        </ClearButton>
      </Header>
      <Body>
        <Box px={[25, 25, 50]} pb={30}>
          <Box mb="20px">
            <Label>{selectedTaxonomy.name}</Label>
          </Box>
          <Flex flexWrap="wrap">
            {selectedTaxonomy.terms &&
              selectedTaxonomy.terms.map((term, index) => (
                <Box key={index} width={1 / 2} mb="10px">
                  <Tag
                    important={term.important}
                    isSelected={term.selected}
                    onClick={() => props.handleClickTerm(term)}
                  >
                    {term.name}
                  </Tag>
                </Box>
              ))}
          </Flex>
        </Box>
      </Body>
      <Footer>
        <Button fullWidth onClick={props.handleClose}>
          <Trans id="metadata.save" message={`Save`} />
        </Button>
      </Footer>
    </Modal>
  );
};

export default SearchFiltersModal;
